import React from "react"
import { partenaireItemDescription } from "../partenaires.module.scss"
import NonStretchedImage from "../../../Image/non-stretched-image"
import PropTypes from "prop-types"
import ProcessedLink from "../../../processed-link"
import { Description } from "../partenaires-styled"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const PartenaireItem = ({ partenaire }) => {
  let image = ""
  if (
    partenaire.relationships.image_direct_link.localFile.extension === "svg"
  ) {
    image = (
      <img
        src={
          partenaire.relationships.image_direct_link.localFile
            .SlugifiedPublicUrl
        }
        alt={partenaire.image_direct_link.alt || ""}
        style={{ margin: "auto" }}
        aria-hidden={true}
      />
    )
  } else if (partenaire.relationships?.image_direct_link?.localFile) {
    image = (
      <NonStretchedImage
        alt={partenaire.image_direct_link.alt}
        {...partenaire.relationships.image_direct_link.localFile}
        style={{ margin: "auto" }}
        ariaHidden={true}
      />
    )
  }
  return (
    <li>
      <EditButton
        link={
          "/admin/structure/direct_link_entity/" +
          partenaire.drupal_internal__id +
          "/edit"
        }
      />
      <ProcessedLink link={partenaire.url.uri}>
        <div>
          {image}
          <Description className={partenaireItemDescription}>
            {partenaire.name}
          </Description>
        </div>
      </ProcessedLink>
    </li>
  )
}

PartenaireItem.propTypes = {
  partenaire: PropTypes.object.isRequired,
}

export default PartenaireItem
